import { createInertiaApp } from "@inertiajs/react";
import { createRoot } from "react-dom/client";
import "../styles/admin/index.scss";
import "../styles/frontend/index.scss";

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob("../pages/**/*.{jsx,tsx}", { eager: true });
    const base = name.split("/").pop()!;
    const page = (
      pages[`../pages/${name}.jsx`] ??
      pages[`../pages/${name}.tsx`] ??
      pages[`../pages/${name}/${base}.jsx`] ??
      pages[`../pages/${name}/${base}.tsx`]
    ) as { default: unknown } | undefined;
    if (!page) throw new Error(`Inertia page not found: ${name}`);
    return page;
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />);
  },
  progress: { color: "#0ea5e9", showSpinner: true },
});
